import cx from "classnames";
import Head from "next/head";
import Link from "next/link";

import { config } from "utils/config.utils";

import SeparatorLeft from "./separator-left.svg";
import SeparatorRight from "./separator-right.svg";

type BreadcrumbPart = {
  label: string | null | undefined;
  to: string;
};

type BreadcrumbProps = {
  parts: BreadcrumbPart[];
  className?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLElement>,
    HTMLElement
  >["className"];
};

const BreadCrumb = ({ parts, className }: BreadcrumbProps) => {
  const generateJsonLd = () => {
    const itemListElement = parts.map((part, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: part.label,
      item: `${config.website_url}${part.to}`,
    }));

    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement,
    };
  };

  const [, previousPart] = [...parts].reverse();

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(generateJsonLd()) }}
        />
      </Head>
      <nav aria-label="breadcrumb" className={cx("m-5", className)}>
        {previousPart && (
          <div className="flex gap-1 lg:hidden">
            <Link href={previousPart.to}>
              <a className="flex font-medium text-black">
                <SeparatorLeft />
                {previousPart.label}
              </a>
            </Link>
          </div>
        )}
        <div className="hidden gap-1 lg:flex">
          {parts.map((part, index) => (
            <div className="flex gap-1" key={index}>
              {parts[index + 1] ? (
                <>
                  <Link href={part.to}>
                    <a className="text-black/60">{part.label}</a>
                  </Link>
                  <SeparatorRight />
                </>
              ) : (
                <>
                  <span className="font-medium text-black">{part.label}</span>
                </>
              )}
            </div>
          ))}
        </div>
      </nav>
    </>
  );
};

export default BreadCrumb;
